import { useEffect } from 'react'
import useAppDispatch from '../../../../hooks/useAppDispatch'
import {
	fetchDeemedVat,
	fetchLastUploadedTansation,
	fetchNews,
	fetchTransByCountryOmp,
	fetchCredits,
	fetchBalanceDashboard
} from '../../../../redux/features/dashboard/dashboardSlice'
import {
	fetchDeclarations,
	fetchDeclarationsSalesTax,
	fetchEprDeclarations
} from '../../../../redux/features/declarations/declarationsSlice'
import { fetchDueDates } from '../../../../redux/features/dueDates/dueDatesSlice'
import { fetchPaymentInfo } from '../../../../redux/features/profile/profileSlice'
import { fetchCompanyDefaultCurrency } from '../../../../redux/features/user/userSlice'
import { fetchBonusProgram } from '../../../../redux/features/tax/taxSlice'
import { fetchThresholdEU, fetchThresholdUS } from '../../../../redux/features/thresholds/thresholdsSlice'
import { fetchCurrentPlan } from '../../../../redux/features/subscription/subscriptionSlice'

const defaultLimitDecl = 3
const defaulLimitDueDates = 4
const defaultLimitNews = 4
const defaulLimitThresholdUS = 10
const defaultLimitTransByCountryOmp = 10

/**
 * Custom hook to fetch dashboard data on mount
 * @param {Object} user - User object
 */
export const useDashboardData = (user) => {
	const dispatch = useAppDispatch()

	useEffect(() => {
		if (!user) return

		// Widgets render their own empty state, so a failed widget request must not
		// bubble up as an unhandled rejection (e.g. 403 on a restricted company).
		const load = (action) => {
			dispatch(action).catch(() => {})
		}

		if (user.is_tax_agent || (user.is_manager && user.company.is_tax_agent)) {
			load(fetchBonusProgram())
		} else {
			load(fetchDueDates({ limit: defaulLimitDueDates }))
		}

		if (user.is_omp) {
			load(fetchDeemedVat())
			load(fetchTransByCountryOmp({
				limit: defaultLimitTransByCountryOmp,
			}))
		}

		load(fetchLastUploadedTansation())
		load(fetchNews({ limit: defaultLimitNews }))
		load(fetchDeclarations({ limit: defaultLimitDecl }))
		load(fetchDeclarationsSalesTax({ limit: defaultLimitDecl }))
		load(fetchEprDeclarations({ limit: defaultLimitDecl }))
		load(fetchThresholdEU({ year: new Date().getFullYear() }))
		load(fetchCredits())
		load(fetchThresholdUS({
			year: new Date().getFullYear(),
			limit: defaulLimitThresholdUS,
		}))
		load(fetchPaymentInfo())
		load(fetchCompanyDefaultCurrency())
		load(fetchBalanceDashboard())
		load(fetchCurrentPlan())
		// Company id, not user id: managers keep the same user when switching clients.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.company?.id])
}

